if (!customElements.get('cart-error-popup')) {
  customElements.define(
    'cart-error-popup',
    class CartErrorPopup extends HTMLElement {
      constructor() {
        super();

        this.content = this.querySelector('.cart-error-popup__content');
        this.messageEl = this.querySelector('.cart-error-popup__message');
        this.openedBy = null;

        this.hide = this.hide.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);

        this.querySelectorAll('[data-cart-error-dismiss]').forEach((el) =>
          el.addEventListener('click', this.hide)
        );
      }

      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          this.show(event);
        });
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      show(event) {
        if (event && event.shownInline) return;

        const message = this.resolveMessage(event);
        if (!message) return;

        // Rendered messages (e.g. quantity errors) may contain markup/links.
        this.messageEl.innerHTML = message;

        this.openedBy = document.activeElement;
        this.removeAttribute('hidden');
        document.body.addEventListener('keyup', this.onKeyUp);
        this.content.focus();
      }

      hide() {
        this.setAttribute('hidden', '');
        document.body.removeEventListener('keyup', this.onKeyUp);
        if (this.openedBy && typeof this.openedBy.focus === 'function') {
          this.openedBy.focus();
        }
        this.openedBy = null;
      }

      onKeyUp(event) {
        if (event.code === 'Escape') this.hide();
      }

      resolveMessage(event) {
        if (!event) return '';

        const raw = event.errors || event.message;

        if (typeof raw === 'string') return raw;

        // Line-item errors come back as an object keyed by field.
        if (raw && typeof raw === 'object') {
          const parts = Object.values(raw).flat().filter(Boolean);
          if (parts.length) return parts.join('<br>');
        }

        return event.message || (window.cartStrings && window.cartStrings.error) || '';
      }
    }
  );
}
